import React, { Component } from "react";
import { connect } from "react-redux";
import { store } from "../../store/ducks/voucher/actions";
import Auxiliary from "../../hoc/Auxiliary/Auxiliary";
import StringInput from "../../components/Input/StringInput/StringInput";
import Button from "../../components/Button/Button";
import { formValidation } from "../../hoc/Shared/utility";
import Swal from "sweetalert2";
// import moment from "moment";
import { withNamespaces } from "react-i18next";
import ValidationError from "../../components/ValidationError/ValidationError";
import Select from "../../components/Input/Select/Select";
import Select2 from "../../components/Input/Select2/Select2";
import DateTimePicker from '../../components/DateTimePicker/DateTimePicker';

class VoucherCreate extends Component {
    constructor(props) {
        const { t } = props;

        super(props);
        this.state = {
            code: "",
            amount: "",
            type: "",
            turnover: 0,
            status: 0,
            set_group: 0,
            start_date: '',//moment().format("YYYY-MM-DD")+" 00:00:00",
            end_date: '',//moment().format("YYYY-MM-DD")+" 00:00:00",
            error_message: [],
            touched: false,
            voucherType: [
                {
                    label: t('voucher.amount'),
                    value: 'amount'
                },
                {
                    label: t('voucher.percentage'),
                    value: 'percentage'
                }
            ],
            voucherCategory: [
                {
                    label: t('voucher.deposit'),
                    value: 'deposit'
                },
                {
                    label: t('voucher.redemption'),
                    value: 'redemption'
                }
            ],
            statusOptions: [
                {
                    label: t('global.inactive'),
                    value: 0
                },
                {
                    label: t('global.active'),
                    value: 1
                },
            ],
            yesNoOptions: [
                {
                    label: t('voucher.no'),
                    value: 0
                },
                {
                    label: t('voucher.yes'),
                    value: 1
                }
            ],
            selectedGroupMember: [],
            searchUsername: '',
            usernameOptions: [],
            max_cap: 0,
            showMaxCap: false,
            showVoucherType: false,
            voucher_list: [{ listIndex: Math.random(), code: ""}],
            limit: "",
            batch_no: "",
            claim_limit: "",
            min_deposit: "",
            number_of_rounds: 10,
            bet_scale: 0.01,
            number_of_valid_days: 1,
            game_codes: [],
            showFreeBetsFields: false,
            gameListOptions: [
                { value: 'vs20starlightx', label: 'Starlight Princess 1000' },
                { value: 'vs20olympx', label: 'Gates of Olympus 1000' },
                { value: 'vs20gatotx', label: 'Gates of Gatot Kaca 1000' },
                { value: 'vs20sugarrushx', label: 'Sugar Rush 1000' },
                { value: 'vs20fruitswx', label: 'Sweet Bonanza 1000' }
            ]
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleGameListChange = this.handleGameListChange.bind(this);
    }

    componentDidMount() {
        formValidation("voucher_form");
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextProps.storeRs !== this.props.storeRs && nextProps.storeRs !== undefined) {
            if (nextProps.storeRs.responseCode === 200 && nextProps.storeRs.msgType === 'success') {
                this.setState({ touched: false });
                const { t } = this.props;
                Swal.fire({
                    title: t("global.record-saved"),
                    icon: nextProps.storeRs.msgType,
                    confirmButtonText: t("global.ok"),
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.props.refreshHandler();
                        this.props.changePageHandler("listing");
                    }
                });
            } else {
                this.setState({
                    touched: true,
                    error_message: nextProps.storeRs.message,
                });
                Swal.close();
            }
        }

        return true;
    }

    storeHandler = (e) => {
        e.preventDefault();
        const { t } = this.props;
        Swal.fire({
            title: t("global.confirmation"),
            text: t("global.are-you-sure"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: t("global.save"),
            cancelButtonText: t("global.cancel"),
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: "",
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    allowEnterKey: false,
                    didOpen: () => {
                        Swal.showLoading();
                    },
                });              

                let value_array = [];

                this.state.voucher_list.forEach((item, idx) => {
                    value_array.push(item.code)
                })


                let storeData = {};
                storeData.code = value_array;
                storeData.amount = this.state.type === "free_bets" ? 0 : this.state.amount;
                storeData.category = this.state.category;
                storeData.type = this.state.type;
                storeData.max_cap = this.state.max_cap;
                storeData.turnover = this.state.turnover;
                storeData.status = this.state.status;
                storeData.start_date = this.state.start_date;
                storeData.end_date = this.state.end_date;
                if(this.state.limit !== ""){
                    storeData.limit = this.state.limit;
                }

                if(this.state.claim_limit !== ""){
                    storeData.claim_limit = this.state.claim_limit;
                }

                if(this.state.min_deposit !== ""){
                    storeData.min_deposit = this.state.min_deposit;
                }

                if(this.state.type === "free_bets"){
                    storeData.number_of_rounds = this.state.number_of_rounds;
                    storeData.bet_scale = this.state.bet_scale;
                    storeData.number_of_valid_days = this.state.number_of_valid_days;
                    storeData.game_codes = this.state.game_codes;
                }

                storeData.batch_no = this.state.batch_no;
                this.props.store(storeData);
            }
        });
    };

    handleChange = (event) => {
        const { t } = this.props;

        // if (event.target.name === 'start_date' || event.target.name === 'end_date') {
        //     event.target.value = moment(event.target.value).format("YYYY-MM-DD HH:mm:ss");
        // }
        
        if (event.target.name === 'code') {
            event.target.value = event.target.value.toUpperCase();
        }

        this.setState({
            [event.target.name]: event.target.value,
        });

        if (event.target.name === 'type') {
            if (event.target.value === "percentage") {
                this.setState({
                    showMaxCap: true,
                    showFreeBetsFields: false
                });
            } else if (event.target.value === "free_bets") {
                this.setState({
                    showMaxCap: false,
                    showFreeBetsFields: true
                });
            } else {
                this.setState({
                    showMaxCap: false,
                    showFreeBetsFields: false
                });
            }
        }

        if (event.target.name === 'category') {
            if (event.target.value === "deposit") {
                this.setState({
                    voucherType: [
                        {
                            label: t('voucher.percentage'),
                            value: 'percentage'
                        },
                        {
                            label: t('voucher.free_bets'),
                            value: 'free_bets'
                        }
                    ],
                    showVoucherType: true,
                    type: ""
                });
            } else if (event.target.value === "redemption") {
                this.setState({
                    voucherType: [
                        {
                            label: t('voucher.amount'),
                            value: 'amount'
                        }
                    ],
                    showVoucherType: true,
                    showMaxCap: false,
                    type: "",
                    min_deposit: "",
                    max_cap: 0
                });
            } else {
                this.setState({
                    showVoucherType: false,
                    showMaxCap: false,
                    type: "",
                    min_deposit: "",
                    max_cap: 0
                });
            }
        }
    };

    handleGameListChange = (event) => {
        // Extract only the values from the selected options
        const gameCodes = event ? event.map(item => item.value) : [];
        this.setState({
            game_codes: gameCodes
        });
    };

    handleGroupMemberSelect = (event) => {
        this.setState({
            selectedGroupMember: event
        });
    };

    handleGroupMember = (event) => {
        let enteredUsername = this.state.searchUsername+event.key;
        this.setState({
            searchUsername: enteredUsername
        });
    }

    memberGroupFocusHandler = (event) => {
        document.addEventListener("keydown", this.handleGroupMember, false);
    }

    memberGroupOutFocusHandler = (event) => {
        document.removeEventListener("keydown", this.handleGroupMember, false);

        this.setState({
            searchUsername: ''
        });
    }

    addRecord = () => {
        this.setState((prevState) => ({
            voucher_list: [...prevState.voucher_list, { listIndex: Math.random(), code: "" }],
        }));
    };

    removeRecord = (i) => {
        // const list = [...this.state.setting_list];
        // list.splice(idx, 1);
        // this.setState({setting_list: list});
        this.setState({
            voucher_list: this.state.voucher_list.filter((item, idx) => i !== idx)
        })
    }

    handleSettingListChange = (event) => {
        let voucher_list = [...this.state.voucher_list];
        voucher_list[event.target.dataset.id][event.target.name] = event.target.value;
        this.setState({ voucher_list });
    }

    render() {
        const { t } = this.props;

        return (
            <Auxiliary>
                <div className="breadcrumb-header">
                    <div className="d-flex">
                        <div className="my-auto">
                            <Button
                                typeButton="button"
                                classValue="btn btn-back-outline"
                                idValue="back"
                                buttonName={<i className="angle fe fe-chevron-left"></i>}
                                clicked={() => this.props.changePageHandler("listing")}
                            />
                        </div>
                    </div>
                    <div className="my-auto">
                        <div className="d-flex">
                            <h4 className="content-title mb-0 my-auto ml-2">{t("voucher.voucher")}</h4>
                        </div>
                    </div>
                </div>
                <div className="row row-sm">
                    <div className="col-lg-12 col-xl-12 col-md-12 col-sm-12">
                        <div className="card box-shadow-0">
                            <div className="card-header">
                                <h4 className="card-title mb-1">{t("voucher.add_voucher")}</h4>
                            </div>

                            <div className="card-body pt-0">
                                <form method="post" id="voucher_form" className="form-horizontal" onSubmit={this.storeHandler} noValidate>
                                    <ValidationError formName="voucher_form" touched={this.state.touched} message={this.state.error_message} />
                                    <div className="row">
                                        {/* <div className="col-md-4">
                                            <div className="form-group">
                                                <label htmlFor="code">{t("voucher.code")}</label>
                                                <StringInput
                                                    id="code"
                                                    name="code"
                                                    className="form-control"
                                                    placeholder={t("voucher.code")}
                                                    value={this.state.code}
                                                    onChange={this.handleChange}
                                                    autoComplete="off"
                                                    autocapitalize="on"
                                                    required
                                                />
                                            </div>
                                        </div> */}
                                         <div className="col-md-4">
                                            <div className="form-group">
                                                <label htmlFor="code">{t("voucher.batch-no")}</label>
                                                <StringInput
                                                    id="batch_no"
                                                    name="batch_no"
                                                    className="form-control"
                                                    placeholder={t("voucher.batch-no")}
                                                    value={this.state.batch_no}
                                                    onChange={this.handleChange}
                                                    autoComplete="off"
                                                    autocapitalize="on"
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label htmlFor="code">{t("voucher.voucher-limit")} ({t("voucher.voucher-limit-remark")})</label>
                                                <StringInput
                                                    id="limit"
                                                    name="limit"
                                                    className="form-control"
                                                    placeholder={t("voucher.voucher-limit")}
                                                    value={this.state.limit}
                                                    onChange={this.handleChange}
                                                    autoComplete="off"
                                                    autocapitalize="on"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label htmlFor="code">{t("voucher.claim-limit")}</label>
                                                <StringInput
                                                    id="claim_limit"
                                                    name="claim_limit"
                                                    className="form-control"
                                                    placeholder={t("voucher.claim-limit")}
                                                    value={this.state.claim_limit}
                                                    onChange={this.handleChange}
                                                    autoComplete="off"
                                                    autocapitalize="on"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label htmlFor="category">{t("voucher.category")}</label>
                                                <Select
                                                    id="category"
                                                    name="category"
                                                    className="form-control"
                                                    onChange={this.handleChange}
                                                    options={this.state.voucherCategory}
                                                    emptyValue={true}
                                                />
                                            </div>
                                        </div>
                                        {this.state.showVoucherType === true && (
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label htmlFor="type">{t("voucher.type")}</label>
                                                    <Select
                                                        id="type"
                                                        name="type"
                                                        className="form-control"
                                                        onChange={this.handleChange}
                                                        options={this.state.voucherType}
                                                        emptyValue={true}
                                                    />
                                                </div>
                                            </div>
                                        )}
                                        {(!!(this.state.type) && this.state.type !== 'free_bets' && (
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label htmlFor="amount">{this.state.type === 'amount' ? t("voucher.amount") : t("voucher.percentage")}</label>
                                                    <StringInput
                                                        id="amount"
                                                        name="amount"
                                                        className="form-control"
                                                        placeholder={this.state.type === 'amount' ? t("voucher.amount") : t("voucher.percentage")}
                                                        type="number"
                                                        value={this.state.amount}
                                                        onChange={this.handleChange}
                                                        autoComplete="off"
                                                        required
                                                    />
                                                </div>
                                            </div>
                                        ))}
                                        {this.state.showMaxCap === true && (
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label htmlFor="max_cap">{t("voucher.max_cap")}</label>
                                                    <StringInput
                                                        id="max_cap"
                                                        name="max_cap"
                                                        className="form-control"
                                                        placeholder={t("voucher.max_cap")}
                                                        value={this.state.max_cap}
                                                        onChange={this.handleChange}
                                                        autoComplete="off"
                                                        required
                                                    />
                                                </div>
                                            </div>
                                        )}
                                        {(this.state.category === 'deposit' && (this.state.type === 'percentage' || this.state.type === 'free_bets')) && (
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label htmlFor="min_deposit">{t("voucher.min-deposit")}</label>
                                                    <StringInput
                                                        id="min_deposit"
                                                        name="min_deposit"
                                                        className="form-control"
                                                        placeholder={t("voucher.min-deposit")}
                                                        value={this.state.min_deposit}
                                                        onChange={this.handleChange}
                                                        autoComplete="off"
                                                    />
                                                </div>
                                            </div>
                                        )}
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label htmlFor="turnover">
                                                    {this.state.category === 'deposit' && this.state.type === 'free_bets'
                                                        ? t("voucher.turnover-fixed")
                                                        : t("voucher.turnover-multiplier")}
                                                </label>
                                                <StringInput
                                                    id="turnover"
                                                    name="turnover"
                                                    className="form-control"
                                                    placeholder={t("voucher.turnover")}
                                                    value={this.state.turnover}
                                                    onChange={this.handleChange}
                                                    autoComplete="off"
                                                    required
                                                />
                                            </div>
                                        </div>
                                        {this.state.showFreeBetsFields === true && (
                                            <>
                                                <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label htmlFor="number_of_rounds">{t("voucher.free_round")}</label>
                                                        <StringInput
                                                            id="number_of_rounds"
                                                            name="number_of_rounds"
                                                            className="form-control"
                                                            type="number"
                                                            placeholder={t("voucher.free_round")}
                                                            value={this.state.number_of_rounds}
                                                            onChange={this.handleChange}
                                                            autoComplete="off"
                                                        />
                                                    </div>
                                                </div>

                                                <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label htmlFor="bet_scale">{t("voucher.bet_scale")}</label>
                                                        <StringInput
                                                            id="bet_scale"
                                                            name="bet_scale"
                                                            className="form-control"
                                                            type="number"
                                                            placeholder={t("voucher.bet_scale")}
                                                            value={this.state.bet_scale}
                                                            onChange={this.handleChange}
                                                            autoComplete="off"
                                                        />
                                                    </div>
                                                </div>

                                                <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label htmlFor="number_of_valid_days">{t("voucher.valid_period_days")}</label>
                                                        <StringInput
                                                            id="number_of_valid_days"
                                                            name="number_of_valid_days"
                                                            className="form-control"
                                                            type="number"
                                                            placeholder={t("voucher.valid_period_days")}
                                                            value={this.state.number_of_valid_days}
                                                            onChange={this.handleChange}
                                                            autoComplete="off"
                                                        />
                                                    </div>
                                                </div>

                                                <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label htmlFor="game_codes">{t("voucher.game_list")}</label>
                                                        <Select2
                                                            id="game_codes"
                                                            name="game_codes"
                                                            className="form-control"
                                                            options={this.state.gameListOptions}
                                                            onChange={this.handleGameListChange}
                                                            value={this.state.game_codes.map(code =>
                                                                this.state.gameListOptions.find(opt => opt.value === code)
                                                            ).filter(Boolean)}
                                                            placeholder={t("global.select")}
                                                        />
                                                    </div>
                                                </div>
                                            </>
                                        )}
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label htmlFor="status">{t("voucher.status")}</label>
                                                <Select
                                                    id="status"
                                                    name="status"
                                                    className="form-control"
                                                    onChange={this.handleChange}
                                                    options={this.state.statusOptions}
                                                    emptyValue={false}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label htmlFor="start_date">{t("voucher.start_date")}</label>
                                                <DateTimePicker
                                                    id='start_date'
                                                    name='start_date'
                                                    className='form-control filter-input'
                                                    singleDatePicker={true}
                                                    timePicker={true}
                                                    value={this.state.start_date}
                                                    onChange={this.handleChange}
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label htmlFor="end_date">{t("voucher.end_date")}</label>
                                                <DateTimePicker
                                                    id='end_date'
                                                    name='end_date'
                                                    className='form-control filter-input'
                                                    singleDatePicker={true}
                                                    timePicker={true}
                                                    value={this.state.end_date}
                                                    onChange={this.handleChange}
                                                    required
                                                />
                                            </div>
                                        </div>

                            
                                            <div className="row col-12 justify-content-end mb-2 pr-0">
                                                <button type="button" className="btn btn-blue" style={{minWidth:'unset'}} onClick={(e) => this.addRecord(e)}>
                                                    <i className="fa fa-plus"></i> {t('global.add')}
                                                </button>
                                            </div>
                                            <div className="table-responsive" style={{ overflowY: 'auto' }}>
                                                <table className="table" id="setting_table" style={{ minWidth: 500 }}>
                                                    <thead className="text-center">
                                                        <tr>
                                                            <th className="p-2">{t("global.no")}</th>
                                                            <th className="">{t("voucher.code")}</th>
                                                            <th style={{ width: "5%" }} />
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {this.state.voucher_list.map((item, idx) => {
                                                            return (
                                                                <tr key={idx} className="text-center">
                                                                    <td>{idx + 1}</td>
                                                                    <td key={`key-${idx}`}>
                                                                        <input
                                                                            id="code"
                                                                            name="code"
                                                                            data-id={idx}
                                                                            className="form-control"
                                                                            placeholder={t("voucher.code")}
                                                                            value={item.code}
                                                                            onChange={this.handleSettingListChange}
                                                                            autoComplete="off"
                                                                        />
                                                                    </td>

                                                                    <td>
                                                                        {/* <i className="fa fa-trash" style={{ color: 'red', cursor: 'pointer' }} onClick={() => this.removeRecord(idx)}></i> */}
                                                                        <button type="button" name="remove" className="remove btn btn-sm btn-white delete" onClick={() => this.removeRecord(idx)}>
                                                                            <i className="fa fa-trash"></i>
                                                                        </button>
                                                                    </td>
                                                                </tr>
                                                            );
                                                        })}
                                                    </tbody>
                                                </table>
                                            </div>
                                    </div>

                                    <div className="form-group mb-0 mt-3 justify-content-end">
                                        <div>
                                            <Button typeButton="submit" classValue="btn btn-blue" idValue="submit" buttonName={t("global.save")} />
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </Auxiliary>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        storeRs: state.voucher.store,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        store: (data) => dispatch(store(data)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces("translation")(VoucherCreate));
